<template>
    <div class="item-divider">
        <el-button type="text" class="remove-btn f-edit" @click="removeItem(ruleForm)"><span
                class="color-danger">删除</span>
        </el-button>
        <el-form :model="ruleForm" :rules="rules" :class="[{ 'form-view': !isEdit }, 'form-switch', 'form-col']"
                 ref="ruleForm"
                 label-width="100px">
            <div class="col-2 clearfix">
                <el-form-item label="项目名称:" prop="name">
                    <p class="f-view" v-text="ruleForm.name"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.name" :maxlength="20"
                              placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="职务:" prop="role">
                    <p class="f-view" v-text="ruleForm.role"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.role" :maxlength="20"
                              placeholder="请输入职务"></el-input>
                </el-form-item>
            </div>
            <div class="col-2 clearfix">
                <el-form-item label="项目描述:" prop="description">
                    <p class="f-view" v-text="ruleForm.description"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.description" :maxlength="20"
                              placeholder="请输入项目描述"></el-input>
                </el-form-item>
                <el-form-item label="职责描述:" prop="responsibility">
                    <p class="f-view" v-text="ruleForm.responsibility"></p>
                    <el-input class="f-edit" v-model.trim="ruleForm.responsibility" :maxlength="20"
                              placeholder="请输入职责描述"></el-input>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="项目时间:" class="width-longer">
                    <p class="f-view" v-text="durationDateText"></p>
                    <div class="f-edit">
                        <el-date-picker type="month" placeholder="开始时间"
                                        ref="startDate"
                                        v-model="ruleForm.beginDate" @change="startDateChange"
                                        :picker-options="startDateOption"></el-date-picker>
                        至
                        <el-date-picker type="month" placeholder="结束时间"
                                        ref="endDate"
                                        v-model="ruleForm.endDate" @change="endDateChange"
                                        :picker-options="endDateOption"></el-date-picker>
                    </div>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
<script type="text/javascript">
    import multiItemMixin from './multiItemMixin'

    export default {
        mixins: [multiItemMixin],
        data () {
            return {
                ruleForm: this.init,
                resetData: Object.assign({}, this.init),
                rules: {
                    name: [
                        {required: true, message: '请输入项目名称', trigger: 'blur'}
                    ],
                    role: [
                        {required: true, message: '请输入职务', trigger: 'blur'}
                    ],
                    description: [
                        {required: true, message: '请输入项目描述', trigger: 'blur'}
                    ],
                    responsibility: [
                        {required: true, message: '请输入职责描述', trigger: 'blur'}
                    ]
                },
                isEdit: !(this.init.isEdit === false)
            }
        }
    }

</script>


// WEBPACK FOOTER //
// project.vue?a6faac90